export default "__VITE_ASSET__pqe816lE__ 740w";